import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../layout/common/Footer'
import Header from '../layout/common/Header'
import NavHeader from '../layout/common/NavHeader'
import SidebarTest from '../layout/common/SidebarTest'
import ViewDetails from '../layout/verifications/ViewDetails'

const ViewRequest = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Verification Requests</title>
      </Helmet>
      <NavHeader />
      <Header />
      <SidebarTest />
      <ViewDetails />
      <Footer />
    </React.Fragment>
  )
}

export default ViewRequest
